import { Bold } from '@tiptap/extension-bold';
import { BulletList } from '@tiptap/extension-bullet-list';
import { Document } from '@tiptap/extension-document';
import { Dropcursor } from '@tiptap/extension-dropcursor';
import { FileHandler } from '@tiptap/extension-file-handler';
import { HardBreak } from '@tiptap/extension-hard-break';
import { History } from '@tiptap/extension-history';
import { Image } from '@tiptap/extension-image';
import { Italic } from '@tiptap/extension-italic';
import { Link } from '@tiptap/extension-link';
import { ListItem } from '@tiptap/extension-list-item';
import { OrderedList } from '@tiptap/extension-ordered-list';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Strike } from '@tiptap/extension-strike';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import { Text } from '@tiptap/extension-text';
import { Underline } from '@tiptap/extension-underline';
export const extensions = [
    Document,
    Paragraph,
    Text,
    History,
    Dropcursor,
    HardBreak,
    Bold,
    Italic,
    Underline,
    Strike,
    Subscript,
    Superscript,
    BulletList,
    OrderedList,
    ListItem,
    Link.configure({ openOnClick: 'whenNotEditable' }),
];
export const imagesExtensions = [
    Image.configure({
        allowBase64: true,
    }),
    FileHandler.configure({
        allowedMimeTypes: ['image/png', 'image/jpeg', 'image/gif', 'image/webp'],
        onDrop: (currentEditor, files, pos) => {
            files.forEach((file) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = () => {
                    currentEditor
                        .chain()
                        .insertContentAt(pos, {
                        type: 'image',
                        attrs: {
                            src: fileReader.result,
                        },
                    })
                        .focus()
                        .run();
                };
            });
        },
        onPaste: (currentEditor, files, pasteContent) => {
            files.forEach((file) => {
                if (pasteContent) {
                    // if there is pasteContent, stop manual insertion & let other extensions handle insertion via inputRule
                    // you could extract the pasted file from this url string and upload it to a server for example
                    return;
                }
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = () => {
                    currentEditor
                        .chain()
                        .insertContentAt(currentEditor.state.selection.anchor, {
                        type: 'image',
                        attrs: {
                            src: fileReader.result,
                        },
                    })
                        .focus()
                        .run();
                };
            });
        },
    }),
];
export const editorProps = {
    attributes: {
        class: 'editor',
    },
};
